<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>设置</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>个人信息</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :model="editForm" label-width="80px">
                    <el-form-item label="姓名">
                        <el-input v-model="editForm.name" placeholder="请输入姓名" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="editForm.email" placeholder="请输入邮箱" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机">
                        <el-input v-model="editForm.mobile" placeholder="请输入手机" size="mini" clearable></el-input>
                    </el-form-item>
                </el-form>
                <el-button @click="onReverst" size="mini">还 原</el-button>
                <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
            </el-card>
            <el-card style="margin-top:16px">
                <el-form class="user-account-key" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
                    <el-form-item label="原密码" prop="password">
                        <el-input type="password" placeholder="请输入原密码" v-model="ruleForm.password" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="iPassword">
                        <el-input type="password" placeholder="请设置新密码" v-model="ruleForm.iPassword" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="rPassword">
                        <el-input type="password" placeholder="请确认新密码" v-model="ruleForm.rPassword" size="mini" clearable></el-input>
                    </el-form-item>
                </el-form>
                <el-button @click="$refs['ruleForm'].resetFields()" size="mini">重置</el-button>
                <el-button type="primary" @click="onSubmitPwd('ruleForm')" size="mini">保存</el-button>
            </el-card>

        </main>
    </div>
</template>
<script>
    export default {
        data() {
            //此处即表单发送之前验证
            let validateNewPassword = (rule, value, callback) => {
                var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');
                if (value === this.ruleForm.password) {
                    callback(new Error('新密码不能与原密码相同!'))
                } else if(!pwdRegex.test(value)) {
                    callback(new Error('密码必须大于8位，且包含大小写英文、数字及特殊符号!'))
                // } else if(value.length<8) {
                //     callback(new Error('密码长度不能小于8位!'))
                // } else if(!value.match(/[a-z]/)) {
                //     console.log(1);
                //     callback(new Error('密码必须包含大小写英文、数字及特殊符号!'))
                // } else if(!value.match(/[A-Z]/)) {
                //     console.log(2);
                //     callback(new Error('密码必须包含大小写英文、数字及特殊符号!'))
                // } else if(!value.match(/\d/)) {
                //     console.log(3);
                //     callback(new Error('密码必须包含大小写英文、数字及特殊符号!'))
                // } else if(!value.match(/[!@#$%^&*()_+-=\[\]{}|;':\",.<>?]/)) {
                //     console.log(4);
                //     callback(new Error('密码必须包含大小写英文、数字及特殊符号!'))
                } else {
                    callback()
                }
            }
            let validateNewPassword2 = (rule, value, callback) => {
                if (value !== this.ruleForm.iPassword) {
                    callback(new Error('与新密码不一致!'))
                } else {
                    callback()
                }
            }
            return {
                editForm: {
                    id: "",
                    name: "",
                    email: "",
                    mobile: "",
                },
                ruleForm: {
                    password: "",
                    iPassword: "",
                    rPassword: "",
                },
                originalSefinfo: {
                    id: "",
                    name: "",
                    email: "",
                    mobile: "",
                },
                rules: {
                    password: [
                        { required: true, message: '请输入原密码', trigger: 'blur' },
                    ],
                    iPassword: [
                        { required: true, message: '请设置新密码', trigger: 'blur' },
                        { validator: validateNewPassword, trigger: 'blur' }
                    ],
                    rPassword: [
                        { required: true, message: '请确认新密码', trigger: 'blur' },
                        { validator: validateNewPassword2, trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            onSubmit() {
                let _this = this;
                this.$axios.post("/admin/rights/staff/modifyProfile", this.editForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            _this.editDialogVisible = false;
                            _this.originalSefinfo.id = _this.editForm.id;
                            _this.originalSefinfo.name = _this.editForm.name;
                            _this.originalSefinfo.email = _this.editForm.email;
                            _this.originalSefinfo.mobile = _this.editForm.mobile;
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },
            onSubmitPwd() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.$axios.post("/admin/rights/staff/modify/password", this.ruleForm)
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {
                                    _this.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    _this.editDialogVisible = false;
                                    _this.ruleForm.password = "";
                                    _this.ruleForm.iPassword = "";
                                    _this.ruleForm.rPassword = ""
                                    _this.onSearch();
                                } else {
                                    _this.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });
                    }
                })
            },
            onReverst() {
                this.editForm.id = this.originalSefinfo.id;
                this.editForm.name = this.originalSefinfo.name;
                this.editForm.email = this.originalSefinfo.email;
                this.editForm.mobile = this.originalSefinfo.mobile;
                this.editForm.iPassword = this.originalSefinfo.iPassword;
                this.editForm.rPassword = this.originalSefinfo.rPassword;
            },
            initData(){
                let _this = this;
                this.$axios.get("/admin/settings/selfinfo")
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            _this.editForm.id = resp.data.id;
                            _this.editForm.name = resp.data.name;
                            _this.editForm.email = resp.data.email;
                            _this.editForm.mobile = resp.data.mobile;
                            _this.editForm.iPassword = resp.data.iPassword+"";
                            _this.editForm.rPassword = resp.data.rPassword;
                            _this.originalSefinfo.id = resp.data.id;
                            _this.originalSefinfo.name = resp.data.name;
                            _this.originalSefinfo.email = resp.data.email;
                            _this.originalSefinfo.mobile = resp.data.mobile;
                            _this.originalSefinfo.iPassword = resp.data.iPassword+"";
                            _this.originalSefinfo.rPassword = resp.data.rPassword;
                        }

                    });
            }
        },
        created() {
            this.initData();
        },
    }
</script>
<style>
</style>
